export default "__VITE_ASSET__r5V63TEV__"